// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-virtual-list .react-grid-Header{display:none;height:0 !important}.ac-virtual-list .react-grid-Viewport{top:0 !important}.ac-virtual-list .react-grid-Canvas{max-height:40rem}\n", ""]);
// Exports
module.exports = exports;
